import { render } from "./productLarge.vue?vue&type=template&id=820ce604&scoped=true"
import script from "./productLarge.vue?vue&type=script&lang=js"
export * from "./productLarge.vue?vue&type=script&lang=js"

import "./productLarge.vue?vue&type=style&index=0&id=820ce604&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-820ce604"]])

export default __exports__